import React, { useEffect, useState } from "react";

//UI Material
import { Box, Breadcrumbs, CircularProgress, Grid, Link } from "@mui/material";

//Local components
import ProductSummary from "../Components/produced-item-page/ProducedItemSummary";
import InteractionsHistory from "../Components/produced-item-page/ProducedItemInteractions";
import ProducedItemSpecifications from "../Components/produced-item-page/ProducedItemSpecifications";
import ProducedItemStatus from "../Components/produced-item-page/ProducedItemStatus";
import ProducedItemTesting from "../Components/produced-item-page/ProducedItemTesting"
import ErrorBox from "../Components/ErrorBox";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

export default function ProducedItem() {
  // ==========> Component States <==========
  //State for interactions
  const [interactions, setInteractions] = useState([]);
  //State for interactions loader
  const [interactionsLoading, setInteractionsLoading] = useState(true);
  //State for store order data
  const [product, setProduct] = useState({});
  //State for loading
  const [isLoading, setIsLoading] = useState(true);
  //State for error case
  const [dataError, setDataError] = useState(false);

  // ==========> Component Functions <==========
  //Function to get product data from db
  const getProductData = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/orders/get-product`,
        {
          productId: new URLSearchParams(window.location.search).get(
            "productId"
          ),
        }
      );
      const jsonResponse = await requestResponse.json();
      setProduct(jsonResponse.data);
    } catch (error) {
      setDataError(true);
    }
    setIsLoading(false);
  };

  //Function to get product interactions from db
  const getProductInteractions = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/interactions/get-product-interactions",
        {
          productId: new URLSearchParams(window.location.search).get(
            "productId"
          ),
        }
      );
      const jsonResponse = await requestResponse.json();
      setInteractions(jsonResponse.data);
    } catch (error) {
      setInteractions([]);
    }
    setInteractionsLoading(false);
  };

  //Function to generate product component
  const generateProductComponent = () => {
    if (isLoading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      );
    } else {
      return (
        <Grid
          container
          spacing={1}
          justifyContent="center"
          textAlign="center"
          sx={{ padding: "15px" }}
        >
          <Grid item xs={12} sx={{ mb: 1 }}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/orders">
                Órdenes
              </Link>
              <Link
                underline="hover"
                color="inherit"
                href={`/order?orderId=${product.productId.slice(
                  0,
                  product.productId.indexOf("-")
                )}`}
              >
                {`Orden ${product.productId.slice(
                  0,
                  product.productId.indexOf("-")
                )}`}
              </Link>
              <Link underline="hover" color="text.primary" aria-current="page">
                {`Producto ${product.productId}`}
              </Link>
            </Breadcrumbs>
          </Grid>
          <Grid item xs={12} md={3} xl={2}>
            <ProductSummary data={product} />
          </Grid>

          <Grid item xs={12} md={9} xl={10}>
            <Grid container alignItems={"stretch"} spacing={1}>
              <Grid item xs={12}>
                <ProducedItemStatus
                  product={product}
                  interactions={interactions}
                  getInteractions={getProductInteractions}
                  getProductData={getProductData}
                />
              </Grid>
              {/*<Grid item xs={12}>
                <ProductTesting />
              </Grid>*/}
              <Grid item xs={12} md={7}>
                <ProducedItemSpecifications
                  getProduct={getProductData}
                  product={product}
                  annotations={product.annotations}
                  specifications={product.specifications}
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <InteractionsHistory
                  interactions={interactions}
                  loading={interactionsLoading}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }
  };

  //The useEffect checks for token validation
  useEffect(() => {
    getProductData();
    getProductInteractions();
  }, []);

  if (dataError) {
    return <ErrorBox />;
  }

  return generateProductComponent();
}
